import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField } from '@material-ui/core';
import { roleName, ADD, EDIT, VIEW } from '../../../common/common';
import LevelChoose from '../../Components/LevelChoose';

const Root = styled(Box)({
    width: '100%',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .notesText': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const ADMIN = "admin";
const DEPT = "dept_manager";
class CaseType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prevNumber: "",
            number: "",
            balance: "",
            office: "",
            department: "",
            department_id: "",
            team: "",
            team_id: "",
            member: "",
            member_id: "",
            note: "",
            editable: true,

            caseDeptData: [],
            totalDOTData: [],
            officeData: [],
            departmentsData: [],
            teamsData: [],
            membersData: [],
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const { state } = this.props;
        const {
            number,
            balance,
            note,
            editable,
        } = this.state;
        const balanceView = () => {
            if (state !== ADD) {
                return <TextField
                    disabled={true}
                    className="textField"
                    id="balance"
                    label="Balance"
                    value={balance}
                    margin="dense"
                    variant="outlined"
                />
            }
        }
        return (
            <Root>
                <div className="textWapper">
                    <div className="title">Case Info</div>
                    <TextField
                        disabled={this.isCaseNumberDisabled()}
                        className="textField"
                        id="number"
                        label="Case Number"
                        value={number}
                        onChange={e => this.handleChange(e, 'number')}
                        margin="dense"
                        variant="outlined"
                    />
                    {balanceView()}
                    <div className="title">Originating Department / Team / Attorney</div>
                    <LevelChoose
                        ref={(child) => { this.levelChoose = child }}
                        officeName={this.getHandleData("office")}
                        deptId={this.getHandleData("dept")}
                        teamId={this.getHandleData("team")}
                        memberId={this.getHandleData("member")}
                        state={this.props.state}
                        isDisabled={this.isDisabled()}
                        editable={editable}
                        viewData={this.getHandleData("view")}
                    />
                    {/* <div className="title">Participants</div>
                    <Participate
                        ref={(child) => { this.participate = child }}
                        userList={this.userFormat()}
                        state={this.props.state}
                        addBtnName="add another participant"
                    /> */}
                    <div className="title">Notes</div>
                    <TextField
                        disabled={this.isDisabled()}
                        id="notes"
                        className="notesText"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows="4"
                        inputProps={{ 'aria-label': 'bare' }}
                        value={note}
                        onChange={e => this.handleChange(e, 'note')}
                    />
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.setBalance();
        this.initData();
    }
    setBalance() {
        const { data, state } = this.props;
        if (state !== ADD) {
            this.setState(() => ({
                balance: data.balance
            }))
        }
    }
    initData() {
        const { data, state } = this.props;
        if (state === VIEW || state === EDIT) {
            console.log(data)
            const prevNumber = data.number;
            const number = data.number;
            const note = data.note ? data.note : "";
            const editable = data.editable ? data.editable : false;
            this.setState(() => ({
                prevNumber,
                number,
                note,
                editable,
            }));
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isCaseNumberDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleCaseSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    //选择
    handleSelect(e, name) {
        const value = e.target.value;
        if (roleName === ADMIN || roleName === DEPT) {
            this.setNextData(name, value);
        }
        this.setState(() => ({
            [name]: value
        }))
    }
    getData() {
        const {
            prevNumber,
            number,
            note
        } = this.state;
        const { state } = this.props;
        let teamObj = this.levelChoose.getData();
        const handler_department_id = teamObj.handler_department_id;
        let userObj = {};
        userObj.handler_id = teamObj.handler_id;
        userObj.handler_team_id = teamObj.handler_team_id;
        userObj.is_origin_attorney = true;
        const attorneyArr = [userObj];
        const asObjFormat = this.editAttorney(attorneyArr);//结构：{addHandler,delHanlder}
        // const psObjFormat = this.participate.getData();//结构：{addMembers,delMembers}
        const psObjFormat = { addMembers: [], delMembers: [] };//结构：{addMembers,delMembers}
        console.log("psObjFormatpsObjFormat", psObjFormat)
        const handlers = this.mergeHandlers(asObjFormat, psObjFormat);

        let newNumber = "";
        if (state !== ADD) {
            newNumber = prevNumber !== number ? number : null;
        } else {
            newNumber = number
        }
        let obj = {
            "number": newNumber,
            "department_id": handler_department_id,
            "notes": note,
            handlers,
        }
        return obj;
    }
    mergeHandlers(attorneyArr, participantArr) {
        const aAddMembers = attorneyArr.addHandler;
        const pAddMembers = participantArr.addMembers;
        const aDelMembers = attorneyArr.delHandler;
        const pDelMembers = participantArr.delMembers;
        const addMembers = aAddMembers.concat(pAddMembers);
        const delMembers = aDelMembers.concat(pDelMembers);
        return { addMembers, delMembers };
    }
    editAttorney(handler) {
        const addHandler = handler;
        const delHandler = this.extDelAttorney();
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = (delHandler.length > 0) ? delHandler[0].handler_id : "";
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = (delHandler.length > 0) ? delHandler[0].handler_team_id : "";
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                return { addHandler: [], delHandler: [] };
            } else {
                return { addHandler, delHandler }
            }
        }
    }
    extDelAttorney() {
        const { data } = this.props;
        if (!data) return [];
        const handlers = data.handler;
        if (!handlers) return [];
        let handlerObj = [];
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                let newObj = {};
                newObj.handler_id = obj.user.id;
                newObj.handler_team_id = obj.team.id;
                newObj.is_origin_attorney = obj.is_origin_attorney;
                handlerObj.push(newObj);
                return handlerObj;
            }
        }
        return [];
    }
    getHandleData(name) {
        const handlers = this.extAOrP("attorney");
        if (handlers.length <= 0) return "";
        const obj = handlers[0];
        const userObj = obj.user;
        const deptObj = obj.team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        } else if (name === "view") {
            return obj;
        }
    }
    userFormat() {
        const users = this.extAOrP();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let obj = {};
                obj.handler_id = userObj.user.id;
                obj.handler_team_id = userObj.team ? userObj.team.id : null;
                obj.is_origin_attorney = userObj.is_origin_attorney;
                userList.push(obj);
            }
            return userList;
        }
        return [];
    }
    extAOrP(type) {
        const { data } = this.props;
        if (!data) return [];
        let attorneyArr = [];
        let participateArr = [];
        const handlerArr = data.handler;
        if (!handlerArr) return [];
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyArr.push(obj);
            } else {
                participateArr.push(obj);
            }
        }
        if (type === "attorney") {
            return attorneyArr;
        } else {
            return participateArr;
        }
    }
}

export default CaseType;